import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
// This service is responsible for handling authentication-related tasks
export class AuthService {
  constructor(
    private router: Router
  ) { }

  // This method logs out the user by removing the token from local storage and redirecting to the login page
  public logout() {
    // Clear the token from local storage and redirect to login page
    localStorage.clear();
    this.router.navigate(['/login']); // Redirect to login page
  }
  // This method retrieves the token from local storage

  public getToken() {
    const token = localStorage.getItem('token');
    if (!token) {
      return '';
    }
    return 'Bearer ' + token.replace(/['"]+/g, '');
  }

  public checkTokenExpiry() {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiryDate = new Date(payload.exp * 1000);
    const currentDate = new Date();
    return currentDate < expiryDate; // Check if the token is still valid
  }

  public isAuthenticated(cb?: any) {
    if (this.checkTokenExpiry()) {
      typeof cb === 'function' && cb(true); // If the token is valid, call the callback with true
    } else {
      typeof cb === 'function' && cb(false); // If the token is expired, call the callback with false
    }
  }

  public setToken(token: string) {
    localStorage.setItem('token', token);
  }

  public setUser(user: any) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  public getUser() {
    const user = localStorage.getItem('user');
    if (!user) {
      return null;
    }
    return JSON.parse(user);
  }

}